<article>
  <h3 *ngIf="data.header" class="d-flex align-items-center">
    <mat-icon *ngIf="data.showIcon" class="warning-icon">warning</mat-icon>
    <span>{{ data.header }}</span>
  </h3>

  <mat-dialog-content *ngIf="data.message" [innerHtml]="data.message"> </mat-dialog-content>

  <mat-dialog-actions class="justify-content-end">
    <div class="row justify-content-end">
      <div class="col">
        <button *ngIf="data.showCancelButton" mat-button [mat-dialog-close]="false">
          {{ data.cancelActionText }}
        </button>
      </div>

      <div class="col">
        <button
          mat-raised-button
          [color]="data.confirmButtonColor"
          [mat-dialog-close]="data.showCancelButton"
        >
          {{ data.confirmActionText }}
        </button>
      </div>
    </div>
  </mat-dialog-actions>
</article>
